import useSWRMutation from 'swr/mutation';
import { DCreateSelfMedicationContact } from '../data/dtos/contact';
import { selfMedicationChatService } from '../services/self-medication';

export function useCreateSelfMedicationConversation({
  userId,
}: Nullable<DCreateSelfMedicationContact>) {
  const execute = async () => {
    return await selfMedicationChatService.createConversation({
      userId: userId!,
    });
  };

  const fetchKey = userId ? ['create-self-medication-contact'] : null;
  const { data, trigger, error, isMutating } = useSWRMutation(
    fetchKey,
    execute
  );

  return {
    data,
    trigger,
    error,
    isLoading: isMutating,
  };
}
